import styles from './Footer.module.css';
import Button from '../Button/Button';

const Footer = () => {
  return (
    <div className={styles.footer}>
        <h3>Developed By </h3>
        <a href="https://www.linkedin.com/in/kishan-ambaliya/" target="_blank" rel='noreferrer'><Button text='KISHAN AMBALIYA' /></a>
    </div>
  )
}

export default Footer;